/* src/app/components/lead-details/documents/file-upload/file-upload/file-upload.component.css */
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
  cursor: pointer;
}
.auth-table-width {
  width: 55rem;
}
::ng-deep .ant-form-item-label {
  text-align: left;
  margin-bottom: 10px;
  font-weight: 600;
}
.text-preview {
  max-height: 85vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 12px;
}
/*# sourceMappingURL=file-upload.component-V4RNMMYW.css.map */
